import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class JobOfferLandingPage extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get id() {
    return this.system.id;
  }

  get image() {
    return get(this, '_asset.value[0].url', {});
  }

  get slug() {
    return get(this, '_slug.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/JobOfferLandingPage.model.js